import * as findConversationShapeUtil from './utils/findConversationShapeUtil';
import type BaseFolderId from 'owa-service/lib/contract/BaseFolderId';
import type BasePagingType from 'owa-service/lib/contract/BasePagingType';
import type ConversationQueryTraversal from 'owa-service/lib/contract/ConversationQueryTraversal';
import findConversationOperation from 'owa-service/lib/operation/findConversationOperation';
import type FindConversationRequest from 'owa-service/lib/contract/FindConversationRequest';
import findConversationRequest from 'owa-service/lib/factory/findConversationRequest';
import type FindConversationResponseMessage from 'owa-service/lib/contract/FindConversationResponseMessage';
import type FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import type SortResults from 'owa-service/lib/contract/SortResults';
import targetFolderId from 'owa-service/lib/factory/targetFolderId';
import type ViewFilter from 'owa-service/lib/contract/ViewFilter';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

interface FindConversationRequestParams {
    folderId: BaseFolderId;
    paging: BasePagingType;
    viewFilter: ViewFilter;
    sortResults: SortResults[];
    focusedViewFilter: FocusedViewFilter;
    findConversationShapeName: string;
    categoryFilter?: string;
    traversal?: ConversationQueryTraversal;
}

function configureRequestBody({
    folderId: currentFolderId,
    paging,
    viewFilter,
    sortResults,
    focusedViewFilter,
    findConversationShapeName,
    categoryFilter,
    traversal,
}: FindConversationRequestParams): FindConversationRequest {
    return findConversationRequest({
        ParentFolderId: targetFolderId({ BaseFolderId: currentFolderId }),
        ConversationShape: findConversationShapeUtil.getFindConversationResponseShape(),
        ShapeName: findConversationShapeName,
        Paging: paging,
        ViewFilter: viewFilter,
        SortOrder: sortResults,
        FocusedViewFilter: focusedViewFilter,
        CategoryFilter: categoryFilter,
        Traversal: traversal,
    });
}

export function findConversation(
    findConversationRequestParams: FindConversationRequestParams
): Promise<FindConversationResponseMessage> {
    const requestBody = configureRequestBody(findConversationRequestParams);

    return findConversationOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(response => response.Body);
}
